/**
 * The base color palettes for the Material Dashboard 2 React.
 */

const palettes = {
  blue: {
    main: "#1A73E8",
    focus: "#1662C4",
  },
  green: {
    main: "#4CAF50",
    focus: "#67bb6a",
  },
  purple: {
    main: "#9c27b0",
    focus: "#ba68c8",
  },
  orange: {
    main: "#fb8c00",
    focus: "#fc9d26",
  },
  red: {
    main: "#F44335",
    focus: "#f65f53",
  },
};

export default palettes;
